import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map } from 'rxjs';
import { MBannerImageListResponse, MGenderSupplimentRequest, MGenderSupplimentResponse, MTrendingProductRequest, MTrendingProductResponse } from 'src/app/pages/homepage/homepage.module';
import { UtilsService } from 'src/app/utils/utils.service';

@Injectable({
  providedIn: 'root'
})
export class WsLandingService {

  constructor(private httpClient: HttpClient) { }

  /**
  * Date:- 09-06-2023
  * Method :- This method is used for image List By Code And Type
  * @param type :-  This param is used for get Images By Code
  * @returns 
  */
  getImageListByCodeAndType(type: any): Observable<MBannerImageListResponse> {
    const headers = {
      'Content-Type': 'application/json'
    }
    return this.httpClient.post<MBannerImageListResponse>(UtilsService.BASE_URL + UtilsService.IMAGELISTBYCODEANDTYPE, type, { headers: headers })
      .pipe(
        map(response => {
          return response;
        }), catchError(UtilsService.ErrorHandler.handleError('getData'))
      )
  }

  /** 
  * Date:- 10-06-2023
  * Method :- This method is used for suppliments by Gender
  * @param getSuppimentReq  This param is used to request for Getting suppliments by Gender
  * @returns 
  */
  getPoductByGenderSuppiment(getSuppimentReq: MGenderSupplimentRequest): Observable<MGenderSupplimentResponse> {
    var jsonBody = JSON.stringify(getSuppimentReq)
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    return this.httpClient.post<MGenderSupplimentResponse>(UtilsService.BASE_URL + UtilsService.PRODUCTBYGENDERSUPPLIMENT, jsonBody, httpOptions)
      .pipe(
        map(response => {
          return response;
        }), catchError(UtilsService.ErrorHandler.handleError('getData'))
      )
  }

  /** 
  * Date:- 10-06-2023
  * Method :- This method is used for Get trending Products
  * @param getTrendingProductReq  This param is used to request for Get trending Products
  * @returns 
  */
  getTrendingPoduct(getTrendingProductReq: MTrendingProductRequest): Observable<MTrendingProductResponse> {
    var jsonBody = JSON.stringify(getTrendingProductReq)
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    return this.httpClient.post<MTrendingProductResponse>(UtilsService.BASE_URL + UtilsService.TRENDINGPRODUCT, jsonBody, httpOptions)
      .pipe(
        map(response => {
          return response;
        }), catchError(UtilsService.ErrorHandler.handleError('getData'))
      )
  }

  /**
* Date:- 09-06-2023
* Method :- This method is used to get customer product and brand lists
* @param input :-  This param is used for getting product and brand lists
* @returns 
*/
  getCustomerProducts(input: any): Observable<any> {

    const headers = {
      'Content-Type': 'application/json'
    }
    return this.httpClient.post<any>(UtilsService.BASE_URL + UtilsService.SEARCHCUSTOMERPRODUCTSBRANDS + "?searchText=" + input+"&skip=0&take=1000", { headers: headers })
      .pipe(
        map(response => {
          return response;
        }), catchError(UtilsService.ErrorHandler.handleError('getData'))
      )
  }
}
